<template>

    <div class="modal fade" ref="modal" id="passChangeDialog" >

      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">



                <div class="modal-header dark-bg">
                  <div class="col-auto me-auto ">
                    <h3>Zmiana hasła</h3>
                  </div>
                  <div class="col-auto d-flex align-items-center">
                    <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                </div>



                <div class="form-control">
                  <form>


                    <div class="PopupLogin">
                      <i class="fas fa-lock"></i>
                      <input ref="input" type="password" class="form-control " placeholder="Stare hasło" :class="{ 

                        'is-invalid': $v.creds.old_pass.$invalid && $v.creds.old_pass.$dirty,
                        'is-valid': !$v.creds.old_pass.$invalid && $v.creds.old_pass.$dirty 

                      }" v-model="creds['old_pass']"  @keyup.enter="doChange" @input="$v.creds.old_pass.$touch();"> <br>

                    </div>



                    <div class="PopupLogin">
                      <i class="fas fa-lock"></i>
                      <input ref="input" type="password" class="form-control " placeholder="Nowe hasło" :class="{ 

                        'is-invalid': $v.creds.new_pass.$invalid && $v.creds.new_pass.$dirty,
                        'is-valid': !$v.creds.new_pass.$invalid && $v.creds.new_pass.$dirty 

                      }" v-model="creds['new_pass']"  @keyup.enter="doChange" @input="$v.creds.new_pass.$touch();"> <br>

                    </div>


                    <div class="PopupHaslo">
                      <i class="fas fa-lock"></i>
                      <input ref="input" type="password" class="form-control " placeholder="Powtórz hasło" :class="{ 

                        'is-invalid': $v.creds.repeat_pass.$invalid && $v.creds.repeat_pass.$dirty,
                        'is-valid': !$v.creds.repeat_pass.$invalid && $v.creds.repeat_pass.$dirty 

                      }" v-model="creds['repeat_pass']"  @keyup.enter="doChange" @input="$v.creds.repeat_pass.$touch();"> <br>
                    </div>

                    <div class="PopupError">

<!-- 
<pre>
  {{ creds }}
</pre>

<pre>
{{ $v }}
</pre> -->

                      <p v-if="$v.creds.old_pass.$invalid && $v.creds.old_pass.$dirty " style="color:red;" class="validatePassword">* Wprowadź aktualne hasło</p>
                      <p v-if="$v.creds.new_pass.$invalid && $v.creds.new_pass.$dirty " style="color:red;" class="validatePassword">* Wprowadź nowe hasło - min. 6 znaków</p>
                      <p v-if="$v.creds.repeat_pass.$invalid && $v.creds.repeat_pass.$dirty" style="color:red;" class="validatePassword">* Wprowadzone ponownie nowe hasło nie jest takie samo</p>
                      <p v-if="err" style="color:red;" class="validatePassword" v-dynamic="err"></p>

                    </div>
                  </form>
                </div>
                <div class="modal-footer d-flex justify-content-evenly">


                  <form>
                    <b-col lg="4" class="pb-2">
                      <a class="form-button btn btn-outline-primary btn-lg me-2 login" :class="{ disabled:$v.creds.$invalid  }" @click="doChange" href="#" >Zastosuj</a>
                    </b-col>
                    <!--data-bs-dismiss="modal"-->
                  </form>
                </div>

              </div>
            </div>





    </div>
        
</template>
<script>

  
  import { url, alpha, email, required, minLength, maxLength, sameAs } from 'vuelidate/lib/validators';



  export default {
    
    name: 'PassChange',

    data() {
      return {


        creds: {},


        err: '',

        modal:null

      }
    },
    methods: {

      doChange() {


        this.post( '/client/password', {
          client_password: this.creds.new_pass.trim()
        } )
          .then(response => {

            if (!!response.data) {           
              if (!(response.data.IS_ERROR | 0)) {

                this.modal.hide();

                this.toast('Hasło zmienione!');
              }
            }           
          })
          .catch(error => {


            this.err = typeof this.errors == 'object' ? Object.values(this.errors).join('<br/>') : this.errors;
                                
          });









    //    this.$emit('login');


/*          axios.post( __CFG.secondaryEndpoint + '/client/login', {

            client_login: this.creds.user.trim(),
            client_password: this.creds.passwd.trim()

          })
          .then(response => {

         //   page.isLoading = false;

            if (!!response.data) {

              let ok = !(response.data.IS_ERROR | 0);        



           //   console.log('okkk ' + ok)       


            //  console.log(response.data)

              bus.$emit('logged_in');


              localStorage.setItem('user', JSON.stringify(response.data));

              this.modal.hide();

              this.$router.push({path: 'client'});   
                   
            
            }
           

          })
          .catch(error => {
          //  console.log(error);
           

          //    page.isLoading = false;
        

              // Error 
              if (error.response) {


               // console.log(error.response.data);
                 

                  if (!!error.response.data.IS_ERROR) {


                    this.err = true; //{...error.response.data.Message};

                    //this.verifycode_hint = error.response.data.Message.toString();
                  }
                
              } 
            

              //this.form['verifycode'] = '';
              //this.$v.form['verifycode'].$touch();                         

            //console.log('Network error', error);

          });

*/


        

      }
     
    },


    validations(){

      return {
        creds: {
          old_pass: {
            required,
            minLength: minLength(6)
          },

          new_pass: {
            required,
            minLength: minLength(6)
          },

          repeat_pass: {
            required,
            sameAsPassword: sameAs('new_pass')
          }
        }
      }
    },


    computed: {


      invalidOld() {
        return this.isDirty && !this.creds['old_pass']
      },

      invalidPassword() {
        return this.isDirty && !this.creds['passwd']
      },

      invalidCreds() {
        return this.isDirty && this.err
      }
    },



    created() {


      this.listen('pass_change_dialog', () => {

        this.modal.show();
      });
    },


    mounted(){

      this.modal = new bootstrap.Modal(this.$refs['modal']);
    }


  }



</script>
<style scoped>


  a.login {

    width:16rem;
  }

  .PopupLogin, .PopupHaslo {
    position: relative;
  }

  .PopupLogin input, .PopupHaslo input {
    padding-right: 35px !important;
  }

  .PopupLogin i,  .PopupHaslo i {
      opacity: .5;
      position: absolute;
      right: 1rem;
      padding: 17px 20px;
      pointer-events: none;
    }




  .modal-footer {
    justify-content: left;
  }


  
  b-button {
    width: 250px;
    height: 40px;
    color: white;
    background-color: forestgreen;
    display: flex;
    justify-content: center;
  }

  h5 {
    justify-content: center;
  }

  .modal-dialog {
    overflow-y: initial;
    display: flex;
    justify-content: center;
    max-width:700px;
  }

  .modal-title {
    justify-content: center;
  }

  .modal-header {
    display: flex;
    justify-content: center;
    overflow-y: auto;

    text-align:center;
   
  }

  .modal-body {
    overflow-y: auto;
    display: flex;
    justify-content: center;
  }


  .form-button.btn.disabled {
    background-color: #045439;
  }
</style>



// WEBPACK FOOTER //
// src/components/PassChange.vue